















import { Component, Prop, Vue, Emit } from "vue-property-decorator";

@Component({
  components: {}
})
export default class ShowText extends Vue {
  @Prop() private readonly text?: string; //
  @Prop({ default: "" }) private readonly continuous_tag?: string; //

  private showOpen = false;
  private isOpen = false;

  private mounted() {
    // alert('contionu_tan '+ this.continuous_tag)
    // alert('TEXT '+ this.text)
    const domHeight = (this.$refs.showText as any).offsetHeight;
    const fontSize = document.getElementsByTagName("html")[0].style.fontSize;
    if (fontSize) {
      const fontNum = Number(fontSize.substr(0, fontSize.length - 2));
      const lineHeight = fontNum * 0.33;
      if (domHeight > lineHeight * 4.5) {
        this.showOpen = true;
      }
    }
    this.$emit("tall-open", this.showOpen);
  }

  private changeShow() {
    this.isOpen = !this.isOpen;
    // 通知父组件执行操作
    this.$emit("change-click", this.isOpen);
  }

  get className() {
    return this.showOpen ? (this.isOpen ? "text" : "maxText") : "text";
  }
  get overflow() {
    return this.isOpen ? "hidden" : "unset";
  }
}
